import Home from './home/components/Home.vue';
import Login from './users/components/Login.vue';
import Logout from './users/components/Logout.vue';
import UsersIndex from './users/components/Index.vue';
import UsersAdd from './users/components/Add.vue';
import UsersShow from './users/components/Show.vue';
import UsersEdit from './users/components/Edit.vue';
import UsersChangePassword from './users/components/ChangePassword.vue';
import { translater } from './tools/translate';
import { UsersAuthorization } from './authorization/users';
import StatsIndex from './stats/components/Index.vue';
import Account from './users/components/Account.vue';
//import Import from './common/components/Import'
import Instructions from './UserManual/components/Index';
import Feedback from './routes/components/Feedback';

import RoutesIndex from './routes/components/Index.vue';

import { store } from './main';

const routes = [
  {
    path: '/routes/:id/feedback',
    component: Feedback,
    name: 'feedback'
  },
  {
    path: '/',
    component: Home,
    name: 'home',
    meta: {
      heading: translater.__('Home', 'home')
    }
  },

  {
    path: '/user-manual',
    component: Instructions
  },
  {
    path: '/login',
    component: Login,
    meta: {
      heading: translater.__('Login', 'users')
    }
  },
  {
    path: '/logout',
    component: Logout,
    meta: {
      heading: translater.__('Logout', 'users')
    }
  },
  {
    path: '/users',
    component: UsersIndex,
    name: 'usersIndex',
    beforeEnter(to, from, next) {
      UsersAuthorization.authorize(to, next);
    },
    meta: {
      heading: translater.__('Users', 'users')
    }
  },
  {
    path: '/users/add',
    component: UsersAdd,
    name: 'usersAdd',
    beforeEnter(to, from, next) {
      UsersAuthorization.authorize(to, next);
    },
    meta: {
      heading: translater.__('Add', 'users')
    }
  },
  /*{
    path: '/import',
    component: Import,
    name: 'import',
    beforeEnter(to, from, next) {
      UsersAuthorization.authorize(to, next);
    },
    meta: {
      heading: translater.__('Import')
    }
  },*/
  {
    path: '/users/:id/show',
    component: UsersShow,
    name: 'usersShow',
    beforeEnter(to, from, next) {
      UsersAuthorization.authorize(to, next);
    },
    meta: {
      heading: translater.__('', 'users')
    }
  },
  {
    path: '/users/:id/edit',
    component: UsersEdit,
    name: 'usersEdit',

    beforeEnter(to, from, next) {
      UsersAuthorization.authorize(
        to,
        undefined,
        isAdmin => {
          if (isAdmin) {
            UsersAuthorization.exists(to)
              .then(user => {
                if (user.data) {
                  next();
                } else {
                  next(new Error('User not found'));
                }
              })
              .catch(() => {
                next(new Error('Edit your own profile via account'));
              });
          } else {
            next(new Error('Unauthorized'));
          }
        },
        () => {
          next(false);
        }
      );
    },
    meta: {
      heading: translater.__('', 'users')
    }
  },
  {
    path: '/account',
    component: Account,
    name: 'usersAccount'
  },
  {
    path: '/users/:id/change-password',
    component: UsersChangePassword,
    name: 'usersChangePassword',

    beforeEnter(to, from, next) {
      UsersAuthorization.authorize(
        to,
        undefined,
        isAdmin => {
          if (isAdmin) {
            UsersAuthorization.exists(to)
              .then(user => {
                if (user.data) {
                  next();
                } else {
                  next(new Error('User not found'));
                }
              })
              .catch(() => {
                next(new Error('Edit your own profile via account'));
              });
          } else {
            next(new Error('Unauthorized'));
          }
        },
        () => {
          next(false);
        }
      );
    },
    meta: {
      heading: translater.__('', 'users')
    }
  },
  {
    path: '/routes',
    component: RoutesIndex,
    name: 'routesIndex',
    beforeEnter(to, from, next) {
      store
        .dispatch('auth/user')
        .then(res => {
          const { role } = res.data;
          if (role === 'admin' || role === 'moderator') {
            next();
          } else {
            next({ name: 'home' });
          }
          //console.log("#### routes", res.data)
        })
        .catch(err => {
          next({ name: 'home' });
          console.log(err);
        });
    },
    meta: {
      heading: translater.__('Index', 'routes')
    }
  },
  {
    path: '/stats',
    component: StatsIndex,
    name: 'statsIndex',
    meta: {
      heading: translater.__('Index', 'stats')
    }
  }
];

export default routes;
